import MetricBase from "models/metrics/MetricBase";
import VisibilityGroup from "models/groups/VisibilityGroup";
import i18n from "i18next";
import PercentUnit from "models/metrics/unit/PercentUnit";

class MetricLoseRate extends MetricBase {
    constructor() {
        super({
            field: "metric_lose_rate",
            defaultVisibility: false,
            unit: new PercentUnit(),
            chartName: i18n.t("metrics.tripadvisor.lose_rate.chartName"),
            serieLabel: i18n.t("metrics.tripadvisor.lose_rate.serieLabel"),
            tooltip: i18n.t("metrics.tripadvisor.lose_rate.tooltip"),
            group: new VisibilityGroup(),
        });
    }
}

export default MetricLoseRate;